export default {
    bind(el) {
        el._addActive = () => el.classList.add('touch-active')
        el._removeActive = () => el.classList.remove('touch-active')

        el.addEventListener('touchstart', el._addActive)
        el.addEventListener('touchend', el._removeActive)
        el.addEventListener('touchcancel', el._removeActive)
        el.addEventListener('mousedown', el._addActive)
        el.addEventListener('mouseup', el._removeActive)
        el.addEventListener('mouseleave', el._removeActive)
    },
    unbind(el) {
        el.removeEventListener('touchstart', el._addActive)
        el.removeEventListener('touchend', el._removeActive)
        el.removeEventListener('touchcancel', el._removeActive)
        el.removeEventListener('mousedown', el._addActive)
        el.removeEventListener('mouseup', el._removeActive)
        el.removeEventListener('mouseleave', el._removeActive)
        delete el._addActive
        delete el._removeActive
    }
}